import { useCallback, useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import DashboardLayout from "../../layouts/Dashboard";
import { Button, Grid } from "@mui/material";
import { LoadingButton } from "@mui/lab";
import useDialogs from "../../components/Dialog/useDialogs";
import { FormSection, PageContainer, PageFooter, PageHeader } from "../../components";
import CheckboxField from "../../components/Fields/CheckboxField";
import { TextField2 } from "../../components/Fields/TextField2";
import { TextPhoneField } from "../../components/Fields/TextPhoneField";
import { DateField } from "../../components/Fields/DateField";
import { DateTimeField } from "../../components/Fields/DateTimeField";
import { NumberField } from "../../components/Fields/NumberField";
import { GridItem } from "../../components/Fields/GridItem";
import { ResearchObjectSelect } from "../../components/Select/domainSelects";
import { ServiceGroupSelect } from "../../components/Select/domainSelects";
import { ServiceSubGroupSelect } from "../../components/Select/domainSelects";
import { ServiceKindSelect } from "../../components/Select/domainSelects";
import { GovernmentStandardSelect } from "../../components/Select/domainSelects";
import { TechnicalRegulationsOfCustomsUnionSelect } from "../../components/Select/domainSelects";
import { changeData, changeDataMany } from "../../functions/changeHandlers";
import { addServiceMap } from "../../redux/actions/serviceMapActions";
import { SERVICE_MAP_LIST_ROUTE } from "../../routes";
import { submitData } from "../../functions/submitHandlers";
import { departmentCRUD, divisionCRUD, governmentCRUD, researchObjectCRUD, serviceCRUD, serviceGroupCRUD, serviceKindCRUD, serviceSubGroupCRUD, technicalRegulationsOfCustomsUnionCRUD } from "../../http";
import RestSelect from "../../components/Select/RestSelect";
import useResourceLinq from "../../data/useResourceLinq";
import { equals, page, where } from "../../functions/resourceLinq1";
import Label from "../../components/Fields/label";

export const CreateServiceMap = () => {
    const dispatch = useDispatch();
    const { push } = useHistory();
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState({});
    const [serviceGroupQuery, setServiceGroupQuery] = useState({
        paging: { skip: 0 },
        filter: {
        },
        sort: {
            name: {
                operator: 'asc'
            }
        }
    });
    const [serviceSubGroupQuery, setServiceSubGroupQuery] = useState({
        paging: { skip: 0 },
        filter: {
            // groupId: {
            //     operand1: 0,
            //     operator: 'equals'
            // }
        },
        sort: {
            name: {
                operator: 'asc'
            }
        }
    });
    const [divisionQuery, setDivisionQuery] = useState({
        paging: { skip: 0 },
        filter: {
            // groupId: {
            //     operand1: 0,
            //     operator: 'equals'
            // }
        },
        sort: {
            name: {
                operator: 'asc'
            }
        }
    });
    const [services, setServices] = useState([]);

    const handleChange = useCallback((key, value) => changeData(data, setData, key, value), [data]);
    const handleChangeMany = useCallback((obj) => changeDataMany(data, setData, obj), [data]);

    const serviceResource = useResourceLinq(serviceCRUD);

    const fetchServices = async (groupId, subGroupId) => {        
        const response = await serviceResource.toList(where(page(null, 0, null), {
            groupId: equals(groupId),
            subGroupId: equals(subGroupId),
            typeId: equals(2)
        }));

        setServices(response);
    }

    useEffect(() => {
        if (!data.groupId || !data.subGroupId) {
            setServices([]);
            return;
        }

        fetchServices(data.groupId, data.subGroupId);
    }, [data.groupId, data.subGroupId]);

    useEffect(() => {
        const departmentId = data?.departmentId;

        if (!divisionQuery || !departmentId)
            return;        

        divisionQuery.filter = {
            departmentId: equals(departmentId)
        }
        setDivisionQuery({...divisionQuery});
    }, [data.departmentId]);

    const {alert, DIALOG} = useDialogs();

    const handleSubmit = async () => {
        if (await submitData(data, async () =>
        {
            return true;
        }, setLoading, async () =>
        {
            return await dispatch(addServiceMap(data));
        }))
        {
            return push(SERVICE_MAP_LIST_ROUTE);
        }
    };

    return (
        <DashboardLayout>
            <>
                <DIALOG/>
                <PageHeader heading="Создание новой записи">
                    <Button variant={"text"} onClick={() => push(SERVICE_MAP_LIST_ROUTE)}>
                        Вернуться
                    </Button>
                </PageHeader>
                <PageContainer>
                    <FormSection>
                        <Grid container>
                            <GridItem xs={6}>
                                <RestSelect
                                    restApi={researchObjectCRUD}
                                    id={"object"}
                                    label={"Объект исследования"}
                                    value={data.objectId}
                                    onChange={(value, obj) => handleChangeMany({ researchObject: obj, objectId: value })}
                                    fullWidth
                                />
                            </GridItem>
                            <GridItem xs={6}>
                                <RestSelect
                                    restApi={serviceGroupCRUD}
                                    query={serviceGroupQuery}
                                    id={"group"}
                                    label={"Группа"}
                                    value={data.groupId}
                                    onChange={(value, obj) => handleChangeMany({ serviceGroup: obj, groupId: value })}
                                    fullWidth
                                />
                            </GridItem>
                            <GridItem xs={6}>
                                <RestSelect
                                    restApi={serviceSubGroupCRUD}
                                    query={serviceSubGroupQuery}
                                    id={"subGroup"}
                                    label={"Вид исследования"}
                                    value={data.subGroupId}
                                    onChange={(value, obj) => handleChangeMany({ serviceSubGroup: obj, subGroupId: value })}
                                    fullWidth
                                />
                            </GridItem>
                            <GridItem xs={6}>
                                <RestSelect
                                    restApi={serviceKindCRUD}
                                    id={"kind"}
                                    label={"Метод"}
                                    value={data.kindId}
                                    onChange={(value, obj) => handleChangeMany({ serviceKind: obj, kindId: value })}
                                    fullWidth
                                />
                            </GridItem>
                            <GridItem xs={6}>
                                <RestSelect
                                    restApi={governmentCRUD}
                                    id={"researchStandard"}
                                    label={"НД на метод исследования"}
                                    value={data.researchStandardId}
                                    onChange={(value, obj) => handleChangeMany({ governmentStandard: obj, researchStandardId: value })}
                                    fullWidth
                                />
                            </GridItem>
                            <GridItem xs={6}>
                                <RestSelect
                                    restApi={governmentCRUD}
                                    id={"governmentStandard"}
                                    label={"НД на метод отбора"}
                                    value={data.governmentStandardId}
                                    onChange={(value, obj) => handleChangeMany({ governmentStandard: obj, governmentStandardId: value })}
                                    fullWidth
                                />
                            </GridItem>
                            <GridItem xs={6}>
                                <RestSelect
                                    restApi={technicalRegulationsOfCustomsUnionCRUD}
                                    id={"regulationOfCU"}
                                    label={"Документ санитарно-эпидемиологического нормирования (на соответствие, которого проводится исследование)"}
                                    value={data.regulationOfCUId}
                                    onChange={(value, obj) => handleChangeMany({ regulationOfCU: obj, regulationOfCUId: value })}
                                    fullWidth
                                />
                            </GridItem>
                            <GridItem xs={6}>
                                <RestSelect
                                    restApi={departmentCRUD}
                                    id={"department"}
                                    label={"Лаборатория"}
                                    value={data.departmentId}
                                    onChange={(value, obj) => handleChangeMany({ department: obj, departmentId: value })}
                                    fullWidth
                                />
                            </GridItem>
                            <GridItem xs={6}>
                                <RestSelect
                                    restApi={divisionCRUD}
                                    query={divisionQuery}
                                    id={"division"}
                                    label={"Отдел"}
                                    value={data.divisionId}
                                    onChange={(value, obj) => handleChangeMany({ division: obj, divisionId: value })}
                                    fullWidth
                                />
                            </GridItem>
                        </Grid>
                        <Grid container>
                            <Label>Исследования</Label>
                            <table className="table">
                                <thead>
                                    <th>ID</th>
                                    <th>Наименование</th>
                                    <th>Удален</th>
                                </thead>
                                <tbody>
                                    {services.map(_ => <tr>
                                        <td>{_.id}</td>
                                        <td>{_.name}</td>
                                        <td>{_.isDeleted ? 'Да' : 'Нет'}</td>
                                    </tr>)}
                                </tbody>
                            </table>
                        </Grid>
                    </FormSection>
                </PageContainer>
                <PageFooter>
                    <LoadingButton loading={loading} onClick={handleSubmit}>
                        Создать запись
                    </LoadingButton>
                </PageFooter>
            </>
        </DashboardLayout>
    )
};
